<template>
  <v-app>

    <HeaderApp></HeaderApp>
    <v-content>
      <keep-alive>
        <!-- max="2" -->
        <router-view :key="$route.fullPath"></router-view>
      </keep-alive>
    </v-content>
    <FooterApp />
  </v-app>

</template>

<script>
import HeaderApp from "@/components/HeaderApp";
import FooterApp from "@/components/FooterApp";

export default {
  name: "App",
  components: { HeaderApp, FooterApp }
};
</script>
